// extracted by mini-css-extract-plugin
export var body = "ShortArticle-module--body--3R86I";
export var content = "ShortArticle-module--content--3X7NE";
export var date = "ShortArticle-module--date--mbiGQ";
export var info = "ShortArticle-module--info--D1nhP";
export var media = "ShortArticle-module--media--wCb29";
export var meta = "ShortArticle-module--meta--gSPfO";
export var shortArticle = "ShortArticle-module--short-article--DuvAi";
export var title = "ShortArticle-module--title--On2Ef";